import aisles from './aisles';
import families from './families';
import products from './products';
import users from './users';

export default { aisles, families, products, users };
